import O1HD from "../../../../../engines/gameEngine";
import FoodMaterialConfig, {FoodMaterialEntity} from "../config/FoodMaterialConfig";
import FoodItem from "./FoodItem";

const {ccclass, property} = cc._decorator;
/**
 * 食物 大米
 */
@ccclass
export default class FoodRaceItem extends FoodItem {

    @property({type:cc.Node,displayName:"屎节点 array"})
    shitNodeArray : cc.Node[] = [];
    @property({type:cc.Node,displayName:"大肠数组"})
    intestineNodeArray : cc.Node[] = [];
    @property({type:cc.Node,displayName:"金子数组"})
    goldNodeArray : cc.Node[] = [];
    @property({type:cc.Node,displayName:"鸡蛋数组"})
    eggNodeArray : cc.Node[] = [];
    @property({type:cc.Node,displayName:"龙虾数组"})
    lobsterNodeArray : cc.Node[] = [];
    @property({type:cc.Node,displayName:"空气数组"})
    airNodeArray : cc.Node[] = [];

    @property({type:cc.Node,displayName:"九转大肠"})
    foodJzdc : cc.Node = null;
    @property({type:cc.Node,displayName:"世纪炒饭"})
    foodLjbc : cc.Node = null;
    @property({type:cc.Node,displayName:"怪味米饭"})
    foodGwmf : cc.Node = null;

    onLoad () {
        super.onLoad();
    }

    start () {

    }

    /**
     * 添加 食物
     */
    addFoodMaterial( foodMaterialId : number ){
        if ( this.node ) {
            let foodMaterialEntity : FoodMaterialEntity = FoodMaterialConfig().find((item,index,dataList)=>{
                return item.uniqueId == foodMaterialId;
            });
            if ( !foodMaterialEntity ) {
                return;
            }
            let canChooseId : number;
            switch ( foodMaterialEntity.uniqueId ) {
                case 2 :
                    //龙虾
                    canChooseId = foodMaterialEntity.uniqueId;
                    this._activeItem( this.lobsterNodeArray );
                    break;
                case 4:
                    //奥利给
                    canChooseId = foodMaterialEntity.uniqueId;
                    this._activeItem( this.shitNodeArray );
                    break;
                case 5:
                    //金子
                    canChooseId = foodMaterialEntity.uniqueId;
                    this._activeItem( this.goldNodeArray );
                    break;
                case 6:
                    //土鸡蛋
                    canChooseId = foodMaterialEntity.uniqueId;
                    this._activeItem( this.eggNodeArray );
                    break;
                case 7:
                    //大肠
                    canChooseId = foodMaterialEntity.uniqueId;
                    this._activeItem( this.intestineNodeArray );
                    break;
                case 8:
                    //空气瓶
                    canChooseId = foodMaterialEntity.uniqueId;
                    this._activeItem( this.airNodeArray );
                    break;
            }
            //如果不是可组合食材
            if ( !canChooseId ) {
                this._activeItem( this.otherNodeArray , foodMaterialEntity.imgPath );
            }
        }
    }

    /**
     * 变身
     * @param typeName
     */
    transformation( typeName : string ){
        if ( this.node ) {
            this.normalNode.active = false;
            switch ( typeName ) {
                case "九转大肠":
                    this.foodJzdc.active = true;
                    break;
                case "世纪炒饭":
                    this.foodLjbc.active = true;
                    break;
                case "怪味":
                    this.foodGwmf.active = true;
                    break;
            }
            this.efChangeSp.node.active = true;
            this.efChangeSp.setAnimation( 0 , "animation" , false );
        }
    }
}
